import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
  import useCommonMixin from '@/composables/useCommonMixin'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'TableLesson',
  props: {
    content: {
      type: String,
      required: true,
    },
    formatContent: {
      type: Boolean,
      default: false,
    },
  },
  setup(__props) {

const props = __props;

  

  const { formatPhrase } = useCommonMixin()

  const parsedContent = computed(() => {
    return props.formatContent ? formatPhrase(props.content) : props.content
  })

return { __sfc: true,props, formatPhrase, parsedContent, computed, useCommonMixin }
}

})